import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { StyledModal, colors } from '../theme/sharedComponents'

const HeaderLink = styled.a`
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  border: none;
  border-radius: 0.375rem;
  padding: 0.35rem 0.8rem;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  white-space: nowrap;

  &:hover { background: rgba(255, 255, 255, 0.28); color: #fff; }
`

const PDFObject = styled.object`
  width: 100%;
  height: 70vh;
  border: none;
  display: block;

  @media (max-width: 767px) { height: 60vh; }
`

const MobilePreview = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  min-height: 40vh;
  text-align: center;
  gap: 1rem;

  p { color: ${colors.textLightModeMuted}; margin: 0; }
`

const MobileBtn = styled.a`
  background: ${colors.primary};
  color: #fff;
  border-radius: 0.5rem;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;

  &:hover { background: ${colors.primaryDark}; color: #fff; }
`

interface PdfPreviewModalProps {
  show: boolean
  title: string
  url: string | null
  onHide: () => void
}

const PdfPreviewModal: React.FC<PdfPreviewModalProps> = ({ show, title, url, onHide }) => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 576px)')
    const onChange = () => setIsMobile(mq.matches)
    onChange()
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [])

  return (
    <StyledModal show={show} onHide={onHide} size="xl" centered>
      <StyledModal.Header closeButton>
        <div style={{ display: 'flex', flex: 1, alignItems: 'center', gap: '0.75rem', flexWrap: 'wrap', minWidth: 0 }}>
          <StyledModal.Title style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {title}
          </StyledModal.Title>
          {url && (
            <>
              <HeaderLink href={url} target="_blank" rel="noreferrer">
                <i className="bi bi-box-arrow-up-right" /> Open
              </HeaderLink>
              <HeaderLink href={url} download>
                <i className="bi bi-download" /> Download
              </HeaderLink>
            </>
          )}
        </div>
      </StyledModal.Header>

      <StyledModal.Body style={{ padding: 0 }}>
        {isMobile ? (
          <MobilePreview>
            <p>PDF preview is not available on mobile devices.</p>
            {url && (
              <MobileBtn href={url} target="_blank" rel="noreferrer">
                <i className="bi bi-file-pdf" /> Open PDF
              </MobileBtn>
            )}
          </MobilePreview>
        ) : (
          url && (
            <PDFObject data={url} type="application/pdf" aria-label={title}>
              <embed src={url} type="application/pdf" />
            </PDFObject>
          )
        )}
      </StyledModal.Body>
    </StyledModal>
  )
}

export default PdfPreviewModal
